import React, { useState } from "react";

import { useQuery } from "@apollo/react-hooks";
import { GET_PHOTO_UPLOAD_QUEUE_STATUS } from "../queries";

const useUploadQueueStatus = () => {
    const [uploadStatusMessage, setUploadStatusMessage] = useState("");
    const [photoUploadBalance, setPhotoUploadBalance] = useState(0);
    const [isSuperPhotographer, setIsSuperPhotographer] = useState(false);
    const [canUploadMorePhotos, setCanUploadMorePhotos] = useState(false);
    const [
        hasReachedMaximumPhotosInQueue,
        setHasReachedMaximumPhotosInQueue
    ] = useState(false);
    const [hasFullName, setFullName] = useState(false);
    const [hasVerifiedEmail, setVerifiedEmail] = useState(false);
    const [queueStatusLoading, setQueueStatusLoading] = useState(true);

    useQuery(GET_PHOTO_UPLOAD_QUEUE_STATUS, {
        onCompleted: ({
            photoUploadQueueStatus: {
                uploadStatusMessage,
                hasFullName,
                hasVerifiedEmail,
                photoUploadBalance,
                isSuperPhotographer,
                canUploadMorePhotos,
                hasReachedMaximumPhotosInQueue
            }
        }) => {
            setUploadStatusMessage(uploadStatusMessage);
            setFullName(hasFullName);
            setVerifiedEmail(hasVerifiedEmail);
            setPhotoUploadBalance(photoUploadBalance);
            setIsSuperPhotographer(isSuperPhotographer);
            setCanUploadMorePhotos(canUploadMorePhotos);
            setHasReachedMaximumPhotosInQueue(hasReachedMaximumPhotosInQueue);
            setQueueStatusLoading(false);
        }
    });

    return {
        queueStatusLoading,
        uploadStatusMessage,
        hasFullName,
        hasVerifiedEmail,
        photoUploadBalance,
        isSuperPhotographer,
        canUploadMorePhotos,
        hasReachedMaximumPhotosInQueue
    };
};

export default useUploadQueueStatus;
